import axios from 'axios';

export const estudiantesApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/estudiantes`
});